import { atom } from "recoil";

export const pagePathState = atom({
  key: "pagePath",
  default: "/de",
});
